export default function initHeader() {

    const header = document.querySelector('[data-header]');
    const menu = document.querySelector('[data-menu-overlay]');
    const btnOpen = document.querySelector('[data-menu-open]');
    const btnClose = document.querySelector('[data-menu-close]');

    let menuOpen = false;

    function openMenu() {
        if (!menu) return;

        menuOpen = true;
        menu.classList.add('is-visible');
        document.body.classList.add('menu-open');
    }

    function closeMenu() {
        if (!menu) return;

        menuOpen = false;
        menu.classList.remove('is-visible');
        document.body.classList.remove('menu-open');
    }

    function handleScroll() {
        if (!header) return;

        if (window.scrollY > 5) {
            header.classList.add('is-scrolled');
            document.body.classList.add('scroll');
        } else {
            header.classList.remove('is-scrolled');
            document.body.classList.remove('scroll');
        }
    }

    btnOpen?.addEventListener('click', openMenu);
    btnClose?.addEventListener('click', closeMenu);

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && menuOpen) {
            closeMenu();
        }
    });

    window.addEventListener('scroll', handleScroll, { passive: true });
}
